__turbopack_context__.v({
  "Cont": "ProjectGrid-module-sass-module__MVuwRq__Cont",
  "FeatureProject": "ProjectGrid-module-sass-module__MVuwRq__FeatureProject",
  "Intro": "ProjectGrid-module-sass-module__MVuwRq__Intro",
  "NoProjects": "ProjectGrid-module-sass-module__MVuwRq__NoProjects",
  "ProjectGrid": "ProjectGrid-module-sass-module__MVuwRq__ProjectGrid",
  "Projects": "ProjectGrid-module-sass-module__MVuwRq__Projects",
  "ShowMore": "ProjectGrid-module-sass-module__MVuwRq__ShowMore",
});
